import { makeStyles } from '@fluentui/react-components';

export const usePhoneNumberInputStyles = makeStyles({
    phoneNumberInput: {
        maxWidth: '200px'
    }
});
